import { render } from "./Help.vue?vue&type=template&id=8547011c&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import "./Help.vue?vue&type=style&index=0&id=8547011c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8547011c"

export default script